import React from 'react';
import $ from 'jquery';

import 'summernote/dist/summernote';
import 'summernote/dist/summernote.css';

import 'summernote/lang/summernote-ko-KR.js';
import 'summernote/lang/summernote-ja-JP.js';

import 'bootstrap/js/modal';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/tooltip';

import './CustomEditor.css';

class CustomEditor extends React.Component {
	constructor(props) {
		super(props);

		const randomUid = () => Math.floor(Math.random() * 100000);
		this.uid = `summernote-${randomUid()}`;
		this.editor = {};
	}

	componentDidMount() {
		const options = this.props.options || {};
		const self = this;
		options.callbacks = this.callbacks;
		options.toolbar.map(item => {
			if (item[0] === 'insert' && item[1].indexOf('customPlugin') < 0) {
				item[1].push('customPlugin')
			}
		});

		// Custom image upload
		$.extend($.summernote.plugins, {
			'customPlugin': function (context) {
				var self = this;
				var ui = $.summernote.ui;
				var lang = context.options.langInfo;
				var $editor = context.layoutInfo.editor;
				var options = context.options;

				context.memo('button.customPlugin', function () {
					// Here we create a button
					var button = ui.button({
						// icon for button
						contents: ui.icon(options.icons.picture),
						// tooltip for button
						tooltip: lang.image.insert,
						// Keep button from being disabled when in CodeView
						codeviewKeepButton: false,
						click: function (e) {
							context.invoke('customPlugin.show');
						}
					});
					return button.render();
				});

				this.initialize = function () {
					var $container = options.dialogsInBody ? $(document.body) : $editor;
					// Build the Body HTML of the Dialog.
					var extensionMsg = options.lang === 'en-US'
						? '*Uploadable file format'
						: (options.lang === 'ja-JP' ? '*アップロード可能なファイル形式' : '*업로드 가능한 파일 형식');
					var body = `<div class="note-group-select-from-files">
					<label for="${options.id}" class="note-form-label">${lang.image.selectFromFiles}</label>
							<input id="${options.id}" class="note-image-input" type="file" accept="image/jpeg, image/png, image/jpg, image/bmp, image/gif"/>
							<div class="extension-message">${extensionMsg}: .bmp, .jpg, .jpeg, png, gif</div></div>`;
					// Build the Footer HTML of the Dialog.
					this.$dialog = ui.dialog({
						// Set the title for the Dialog. Note: We don't need to build the markup for the Modal
						// Header, we only need to set the Title.
						title: lang.image.insert,
						// Set the Body of the Dialog.
						body: body,
						// Set the Footer of the Dialog.
						// footer: footer
						// This adds the Modal to the DOM.
					}).render().appendTo($container);
				}

				this.destroy = function () {
					ui.hideDialog(this.$dialog);
					this.$dialog.remove();
				};

				this.show = function () {
					context.invoke('editor.saveRange');

					this.showcustomPluginDialog().then(function (data) {
						ui.hideDialog(self.$dialog);

						context.invoke('editor.restoreRange');

						if (options.callbacks) {
							options.callbacks.onImageUpload(data);
						}
					});
				};

				this.showcustomPluginDialog = function () {
					return $.Deferred(function (deferred) {
						var $imageInput = self.$dialog.find('.note-image-input');

						ui.onDialogShown(self.$dialog, function () {
							context.triggerEvent('dialog.shown');
							
							$imageInput.replaceWith($imageInput.clone().on('change', function (event) {
								deferred.resolve(event.target.files || event.target.value);
							}).val(''));
						});
						ui.onDialogHidden(self.$dialog, function () {
							$imageInput.off();
							if (deferred.state() === 'pending') deferred.reject();
						});
						ui.showDialog(self.$dialog);
					});
				};
			}
		});


		this.editor = $(`#${this.uid}`);
		this.editor.summernote(options);
		this.editor.summernote('code', this.formatter(this.props.value));
		if (this.props.disabled) {
			this.editor.summernote('disable');
		}

		this.editor.on('summernote.codeview.toggled', function (e) {
			if ($(e.target).summernote('codeview.isActivated')) {
				$(e.target).summernote('code', self.formatter(self.props.value));
			}
		});

	}

	// 코드 보기 화면에서 보여줄 소스 코드 개행 처리
	formatter = html => {
		var result = '';

		html.split(/>\s*</).forEach(function (element) {
			result += '<' + element + '>\r\n';
		});

		return result.substring(1, result.length - 3);
	}

	insertImage = (url, filenameOrCallback) => {
		this.editor.summernote('insertImage', url, filenameOrCallback);
	}

	onImageUpload = (images) => {
		const { onImageUpload } = this.props;

		if (typeof onImageUpload === 'function') {
			onImageUpload(images, this.insertImage);
		}
	}

	get callbacks() {
		return {
			onFocus: this.props.onFocus,
			onBlur: this.props.onBlur,
			onChange: this.props.onChange,
			onImageUpload: this.onImageUpload
		}
	}

	render() {
		const { children, className } = this.props;

		return (
			<div className={className}>
				<div id={this.uid}>{children}</div>
			</div>
		);
	}
}

export default CustomEditor;


// WEBPACK FOOTER //
// ./src/script/components/examTemplate/CustomEditor.js